import { EditionAPI } from '../../../api/bussched/EditionAPI';

export class EditionsCommand {
    constructor() {
        this.editionApi = new EditionAPI();
    }

    getNetworks(successCallback, errorCallback) {
        const apiResult = this.editionApi.getNetworks();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}